import React from 'react';
import {GetStaticProps} from 'next';
import {ResultOf} from '@graphql-typed-document-node/core';
import {TitleMetaLinkTag} from 'react-datocms';
import {AboutUsPageDocument} from '../graphql/datocms-generated';
import {useUserQuery} from '../graphql/generated';
import {request} from '../graphql/api';
import {PageLayout} from '../components/global/page-layout';
import {AboutUsComponentLoader} from '../components/sections/loaders/about-us-component-loader';

const AboutUsPage = ({
  pageData,
}: {
  pageData: ResultOf<typeof AboutUsPageDocument>['aboutUsPage'];
}): JSX.Element => {
  const userQuery = useUserQuery();
  return (
    <PageLayout
      firstName={userQuery.data?.user?.firstName}
      additionalContentStyles={{pt: {md: '16px'}}}
      hideShapes
      hideOverflow
      seo={pageData?.seo as TitleMetaLinkTag[]}
    >
      {pageData?.contentBlocks &&
        pageData.contentBlocks.map((section: any) => (
          <>
            <AboutUsComponentLoader
              // eslint-disable-next-line no-underscore-dangle
              component={section._modelApiKey}
              section={section}
            />
          </>
        ))}
    </PageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const [aboutUsPage] = await Promise.all([request(AboutUsPageDocument)]);
  return {
    revalidate: 10,
    props: {
      pageData: aboutUsPage.aboutUsPage,
    },
  };
};

export default AboutUsPage;
